import { SKILL_SLOT_MAX } from "@/character/skills/constants";
import { attackGapMs } from "@/game/model/character-stats";
import { getGameSettings } from "@/game/model/game-settings";

/** Target chain delay at Lv.1 / 0 attack-speed AP (matches ~1s feel at default attack gap). */
export const SKILL_CHAIN_GCD_REFERENCE_MS = 1000;

/** Floor so ultra-high attack speed cannot machine-gun skills across slots. */
export const SKILL_CHAIN_GCD_MIN_MS = 180;

/**
 * Ms before other skill slots can fire after one skill is used.
 * Scales with attack gap (attack speed + level), same curve as normal strikes.
 */
export function skillChainGcdMs(level: number, attackSpeedPoints: number): number {
  const s = getGameSettings();
  const gap = attackGapMs(level, attackSpeedPoints);
  const baseGap = Math.max(1, s.baseAttackGapMs);
  const scaled = Math.round(gap * (SKILL_CHAIN_GCD_REFERENCE_MS / baseGap));
  return Math.max(SKILL_CHAIN_GCD_MIN_MS, scaled);
}

export function applySkillChainGcdToOtherSlots(
  untilBySlot: number[],
  durationBySlot: number[],
  usedSlot: number,
  chainGcdMs: number,
): void {
  const chainUntil = Date.now() + chainGcdMs;
  for (let index = 0; index < SKILL_SLOT_MAX; index += 1) {
    if (index === usedSlot) continue;
    const prev = untilBySlot[index] ?? 0;
    if (chainUntil > prev) {
      untilBySlot[index] = chainUntil;
      durationBySlot[index] = Math.max(1, chainGcdMs);
    }
  }
}

export function applySkillChainGcdToOtherSlotsRecord(
  untilBySlot: Record<number, number>,
  durationBySlot: Record<number, number>,
  usedSlot: number,
  chainGcdMs: number,
): void {
  const chainUntil = Date.now() + chainGcdMs;
  for (let index = 0; index < SKILL_SLOT_MAX; index += 1) {
    if (index === usedSlot) continue;
    const prev = untilBySlot[index] ?? 0;
    if (chainUntil > prev) {
      untilBySlot[index] = chainUntil;
      durationBySlot[index] = Math.max(1, chainGcdMs);
    }
  }
}
